<script>
export default {
  name: 'Blocker',
}
</script>

<template>
  <div class="z-40 bg-black opacity-75 fixed inset-0" />
</template>
